// services/licencia-alert.service.ts
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LicenciaAlertService {

  /** Se emite cada vez que se debe re-evaluar la alerta de licencia */
  private _refrescar$ = new Subject<void>();
  refrescar$ = this._refrescar$.asObservable();

  /** Se emite al cambiar de URL, por si el componente quiere reaccionar */
  private _empresaActualizada$ = new Subject<any>();
  empresaActualizada$ = this._empresaActualizada$.asObservable();

  dispararRefresco(): void {
    this._refrescar$.next();
  }

  notificarEmpresaActualizada(empresa: any): void {
    this._empresaActualizada$.next(empresa);
  }
}